import t from 'react-translate';
import AthenaTextInput from 'athena/components/text-input';
import { config } from '@config/pendo.config.json';
import React from 'react';

type QuestionTextProps = {
  text: string;
  name: string;
  onChange: (event) => void;
};
const QuestionText = React.forwardRef<HTMLInputElement, QuestionTextProps>((
  { text, name, onChange },
  ref,
) => (
  <AthenaTextInput
    ref={ref}
    autoComplete='off'
    required
    withForm
    value={text}
    showLabel={false}
    name={name}
    className='align-content-center'
    onBlur={onChange}
    onKeyDown={(e) => {
      if (e.key === 'Enter') e.preventDefault();
    }}
    placeholder={t.MENTORING_PROGRAMS.SETTINGS.TABS.PROGRAM_PROFILE_SETUP.PROGRAM_LEVEL_FIELDS.PLACEHOLDERS.QUESTION_TEXT()}
    dataQa={config.pendo.athena.mentorshipProgram.settings.programProfileSetup.question.questionTextInputField}
  />
));

export default QuestionText;
